export function isChunkLoadError(error) {
  const message = String(error?.message || error || '');
  return error?.name === 'ChunkLoadError'
    || /Loading chunk [\w.]+ failed/i.test(message)
    || /Failed to fetch dynamically imported module/i.test(message)
    || /ChunkLoadError/i.test(message);
}

export function reloadForNewVersion() {
  const key = 'naewaste-chunk-reload';
  try {
    if (sessionStorage.getItem(key) === '1') return false;
    sessionStorage.setItem(key, '1');
  } catch (err) {
    return false;
  }
  window.location.reload();
  return true;
}
